export default "__VITE_ASSET__BxtJM_L4__"